import React, { Component } from 'react';
import './EditNoticia.css';
import axios from 'axios';
import { BASE_HOST_URL } from '../../config';

class EditNoticia extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editing: false,
    };
    const splitted = props.location.pathname.split('/');
    this.id = splitted[splitted.length - 1];

    this.handleChange = this.handleChange.bind(this);
  }

  async componentDidMount() {
    const {
      data: {
        state: { esTitle, esMessage, catTitle, catMessage, enTitle, enMessage }
      }
    } = await axios.get(`${BASE_HOST_URL}/api/v1/news/${this.id}`);

    this.setState({ esTitle, esMessage, catTitle, catMessage, enTitle, enMessage });
  }

  handleChange(event) {
    const { target: { name, value } } = event
    this.setState({ [name]: value });
  }

  async editNew() {
    try {
      if (!this.state.esTitle) { alert('Falta título en español'); return; }
      if (!this.state.esMessage) { alert('Falta mensaje en español'); return; }

      if (!this.state.catTitle) { alert('Falta título en català'); return; }
      if (!this.state.catMessage) { alert('Falta mensaje en català'); return; }

      if (!this.state.enTitle) { alert('Falta título en english'); return; }
      if (!this.state.enMessage) { alert('Falta mensaje en english'); return; }

      this.setState({ editing: true });
      const new2edit = this.state;
      delete new2edit.editing;
      await axios.put(`${BASE_HOST_URL}/api/v1/news/${this.id}`, new2edit);
      this.setState({ editing: false });
      this.props.history.goBack();
    } catch (err) {
      this.setState({ editing: false });
      console.log(err);
    }
  }

  render() {
    return (
      <div className="createNewWrapper">
        <div className="actionWrapper">
          <button className="btnCreateNew" onClick={() => this.editNew()}>
            {
              this.state.editing
                ? 'GUARDANT...'
                : 'EDITAR ARA'
            }
          </button>
        </div>
        <div className="contentWrapper">
          <div className="langCreateNew">
            <h3 className="nameLang">Español</h3>
            <div className="itemLang">
              <h5>Título</h5>
              <input name="esTitle" value={this.state.esTitle} type="text" className="inputLang" onChange={this.handleChange}></input>
            </div>
            <div className="itemLang">
              <h5>Descripción</h5>
              <textarea name="esMessage" value={this.state.esMessage} rows="4" type="text" className="inputLang" onChange={this.handleChange}></textarea>
            </div>
          </div>
          <div className="langCreateNew">
            <h3 className="nameLang">Català</h3>
            <div className="itemLang">
              <h5>Títol</h5>
              <input name="catTitle" value={this.state.catTitle} type="text" className="inputLang" onChange={this.handleChange}></input>
            </div>
            <div className="itemLang">
              <h5>Descripció</h5>
              <textarea name="catMessage" value={this.state.catMessage} rows="4" type="text" className="inputLang" onChange={this.handleChange}></textarea>
            </div>
          </div>
          <div className="langCreateNew">
            <h3 className="nameLang">English</h3>
            <div className="itemLang">
              <h5>Title</h5>
              <input name="enTitle" value={this.state.enTitle} type="text" className="inputLang" onChange={this.handleChange}></input>
            </div>
            <div className="itemLang">
              <h5>Description</h5>
              <textarea name="enMessage" value={this.state.enMessage} rows="4" type="text" className="inputLang" onChange={this.handleChange}></textarea>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EditNoticia;



// WEBPACK FOOTER //
// ./src/components/EditNoticia/EditNoticia.js